import { createRouter, createWebHistory } from "vue-router";
import store from "./store";
import getPermissions from "@/helpers/getPermissions";
import Login from "@/pages/Login";
import Main from "@/pages/Main";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Contacts from "@/pages/Contacts";
import PotentialCustomers from "@/pages/PotentialCustomers";
import Leads from "@/pages/Leads";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import AccountDetails from "@/pages/AccountDetails";
import CustomerByPhoneResolver from "@/pages/CustomerByPhoneResolver";
import UserRights from "@/pages/UserRights";
import Lock from "@/pages/Lock";
import PriceCategories from "@/pages/PriceCategories";
import PriceCategoriesForSecondAgent from "@/pages/PriceCategoriesForSecondAgent"
import Teams from "@/pages/Teams"
import Policies from "@/pages/Policies"
import TeamTaxes from "@/pages/TeamTaxes";

import CustomerSignature from "@/pages/CustomerSignature";

const routes = [
  { path: "/:pathMatch(.*)*", redirect: { name: "Dashboard" } },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/customerSignature",
    name: "CustomerSignature",
    component: CustomerSignature,
    meta: {
      permission: "default",
    },
  },
  {
    path: "/lock",
    name: "Lock",
    component: Lock,
    meta: {
      permission: "default",
    },
  },
  {
    path: "/",
    name: "Main",
    component: Main,
    redirect: "/dashboard",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/customers",
        name: "Customers",
        component: Customers,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/contacts",
        name: "Contacts",
        component: Contacts,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/potential-customers",
        name: "PotentialCustomers",
        component: PotentialCustomers,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/leads",
        name: "Leads",
        component: Leads,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/reports",
        name: "Reports",
        component: Reports,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/users",
        name: "Users",
        component: Users,
        meta: {
          permission: "user_access",
        },
      },
      {
        path: "/settings",
        name: "Settings",
        component: Settings,
        meta: {
          permission: "default",
        },
      },

      // !!FUTURE CHANGE          
      // 
      // path: "/account-details/:entity/:id",
      {
        path: "/account-details/customer-by-phone/:phone",
        name: "CustomerByPhoneResolver",
        component: CustomerByPhoneResolver,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/account-details/:entity/:id/:subEntityType?/:subEntityId?",
        name: "AccountDetails",
        component: AccountDetails,
        meta: {
          permission: "default",
        },
      },

      {
        path: "/user-rights",
        name: "UserRights",
        component: UserRights,
        meta: {
          permission: "user_management_access",
        },
      },
      {
        path: "/price-categories",
        name: "PriceCategories",
        component: PriceCategories,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/price-categories-for-second-agent",
        name: "PriceCategoriesForSecondAgent",
        component: PriceCategoriesForSecondAgent,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/teams",
        name: "Teams",
        component: Teams,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/team-taxes/:id",
        name: "TeamTaxes",
        component: TeamTaxes,
        meta: {
          permission: "default",
        },
      },
      {
        path: "/policies",
        name: "Policies",
        component: Policies,
        meta: {
          permission: "default",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const checkRolePermission = (permission) =>
    permission === "default"
      ? true
      : getPermissions().some((p) => p.title === permission);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("access_token")) {
      next({ name: "Login" });
    } else if (to.name != "AccountDetails" && sessionStorage.getItem('needs_reset') == 'true') {
      let errorCount = Number(localStorage.getItem("error_count"));
      if (errorCount > 2) {
        localStorage.setItem("error_count", "0");
        store.dispatch('logout');
      } else {
        alert("You should update your account first");
        localStorage.setItem("error_count", String(errorCount + 1));
      }
    } else {
      if (checkRolePermission(to.meta.permission)) {
        next();
      } else {
        next({ name: "Dashboard" });
      }
    }
  } else if (to.name === "Login" && localStorage.getItem("access_token")) {
    next({ name: "Dashboard" });
  } else {
    next();
  }
});

export default router;
